import { StyleSheet } from 'react-native';
import { spacing } from '../../../../theme/tokens';

const styles = StyleSheet.create({
  activitiesTitleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: spacing.small,
  },
  addIcon: {
    margin: 0,
  },
  approvalTitle: {
    alignSelf: 'center',
  },
  deleteIcon: {
    margin: 0,
  },
  flex: { flex: 1 },
  paddingLeftZero: {
    paddingLeft: 0,
  },
});

export default styles;
